import NovaSolicitacaoPopup from '../NovaSolicitacaoPopup';
import { addDays, addYears, differenceInDays, format, isAfter, isBefore, isSameDay, parse } from 'date-fns';
import Dictionary from '@tekvue/assets/interfaces/Dictionary';
import { SolicitacaoController, TiposSolicitacao } from '@/assets/ts/controller/SolicitacaoController';
import SnackbarUtils from '@tekvue/assets/utils/SnackbarUtils';
import DialogUtils from '@tekvue/assets/utils/DialogUtils';
import Util from '@tekvue/assets/utils/Util';
import Field from '@tekvue/assets/interfaces/Field';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { INovaSolicitacao } from '../interfaces';

@Component({
  name: 'NovaSolicitacaoFerias',
})
export default class NovaSolicitacaoFerias extends Vue implements INovaSolicitacao {
  // #region [ DATA ]
  TP_SOLICITACAO = TiposSolicitacao.TP_SOLI_FERIAS;

  main: NovaSolicitacaoPopup | null = null;

  periodoFerias: Dictionary[] = [];

  public get fields(): Field[] {
    return this.main ? [
      {
        name: 'NRFERIAS',
        label: 'Período de Férias',
        type: 'autocomplete',
        size: 6,
        valueField: 'NRFERIAS',
        descriptionField: 'DSPERIODOFERIAS',
        items: this.periodoFerias,
        required: true,
      },
      {
        name: 'DTINIGOZOFERIAS',
        label: 'Data Férias',
        type: 'date',
        size: 6,
        required: true,
        minDate: this.main.getIntervaloDataRegra('min'),
        maxDate: this.main.getIntervaloDataRegra('max'),
      },
      {
        name: 'QTDIASFERIAS',
        label: 'Qtde. Dias de Férias',
        type: 'number',
        size: !this.deveMostrarAdiant13 ? 6 : 4,
        required: true,
        min: 0,
      },
      {
        name: 'QTDIASABONOFERI',
        label: 'Qtde. Dias de abono de Férias',
        type: 'number',
        size: !this.deveMostrarAdiant13 ? 6 : 4,
        max: 10,
        min: 0
      },
      {
        name: 'IDADIANT13SALAR',
        label: 'Adiantamento de 13º',
        type: 'select',
        size: 4,
        required: true,
        isVisible: this.deveMostrarAdiant13,
        valueField: 'value',
        descriptionField: 'name',
        items: [
          {
            name: 'Sim',
            value: 'S',
          },
          {
            name: 'Não',
            value: 'N',
          },
        ],
      },
      {
        name: 'DSGOZOFERIAS',
        label: 'Justificativa',
        type: 'textarea',
        required: false,
        rows: 2,
        size: 6,
      }
    ] : [];
  }

  // #region [ WATCHERS ]
  @Watch('fields')
  private fieldsOnChange() {
    this.main.injectFields(this);
  }

  
  // #region [ ACTIONS ]
  public onAdvance(): void | Promise<void> {
    this.setFeriasFields();
  };

  public async onSaveValidation () {
    const dtinicio =  parse(this.main.row.DTINIGOZOFERIAS, 'dd/MM/yyyy', new Date());

    const sub1Dia = this.main.row.QTDIASFERIAS == 0 ? 0 : 1;

    this.main.row.DTFIMGOZOFERIAS = format(addDays(dtinicio, (this.main.row.QTDIASFERIAS - sub1Dia)), 'dd/MM/yyyy');

    if(!this.main.row.QTDIASABONOFERI) {
      this.main.row.QTDIASABONOFERI = 0;
    }

    return await this.verificaFerias();
  }

  // #region [ METHODS ]
  private async setFeriasFields() {
    await this.main.vinculoDemitidoOuAfastado();

    this.main.loading = true;

    try {
      const [dataPrevious] = await Promise.all([
        this.main.getPreviousDataSolicitation()
      ]);

      const ferias = dataPrevious.map((ferias) => {

        const DSPERIODOFERIAS = `${ferias.DTINIAQUISICAO.split(' ')[0]} - ${ferias.DTFIMAQUISICAO.split(' ')[0]} - ${ferias.IDCONTROLFERIAS}`;

        return {
          ...ferias, DSPERIODOFERIAS
        }
      })

      this.periodoFerias = ferias;

      if(this.main.isEdit) {
        this.main.preencherCamposEdit();
      }

      const defaultRowSalarioCopy = Util.deepCopy(this.main.defaultRowSalario);
      this.main.row = {...this.main.row, ...defaultRowSalarioCopy};

    } finally {
      this.main.loading = false;
    }
  }

  // TODO: Passar essa verificação pro back end
  private async verificaFerias() {
    await this.validaInicioFeriasValida();

    if(!this.validaFeriasMaisAntiga()) {
      return false;
    }

    const nrVinculom = this.main.row.NRVINCULOM;
    const nrFerias = this.main.row.NRFERIAS;
    const dataFerias = await SolicitacaoController.getGozoFeriasVinculo(nrVinculom, nrFerias);

    if(!dataFerias || !dataFerias.FERIAS) {
      const msg = 'Ocorreu um erro ao buscar os dados relacionado as férias do vínculo.';
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    const ferias = dataFerias.FERIAS;
    const gozoFerias = dataFerias.GOZOFERIAS;


    const dtFimAquisicao = parse(ferias.DTFIMAQUISICAO.split(' ')[0], 'dd/MM/yyyy', new Date());
    const proxDtAquis = addDays(dtFimAquisicao, 1);

    const validStatuses = ["ADQUIRIDO", "GOZADO_PARCIAL", "ABERTO"];

    if (!validStatuses.includes(ferias.IDCONTROLFERIAS)) {
      const msg = `Colaborador não possui férias com status ADQUIRIDO. Só poderá gozar férias a partir do dia ${format(proxDtAquis, 'dd/MM/yyyy')}. Favor Alterar.`;
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    const dtIniGozoFeriasNovo = parse(this.main.row.DTINIGOZOFERIAS, 'dd/MM/yyyy', new Date());
    const dtFimGozoFeriasNovo = parse(this.main.row.DTFIMGOZOFERIAS, 'dd/MM/yyyy', new Date());
    const qtMaxFerias = ferias.QTDIASMAXFE;
    const qtMaxAbonoFerias = ferias.QTDIASMAXABON || 10;
    const feriasReduzidas = qtMaxFerias < 30;

    let limiteFerias = qtMaxFerias;
    let limiteAbonoFerias = qtMaxAbonoFerias;
    let diasAbonados = 0;
    let dtIniGozoFeriasExiste = null;
    let dtFimGozoFeriasExiste = null;
    let isMesmoPeriodoGozoFerias = false;
    let existePeriodo14 = false;

    if(gozoFerias && gozoFerias.length) {

      gozoFerias.forEach(gzFerias => {
        const dtIniGozoFerias = parse(gzFerias.DTINIGOZOFERIAS, 'dd/MM/yyyy HH:mm:ss', new Date());
        const dtFimGozoFerias = parse(gzFerias.DTFIMGOZOFERIAS, 'dd/MM/yyyy HH:mm:ss', new Date());
        const diferencaDias = differenceInDays(dtFimGozoFerias, dtIniGozoFerias) + 1;

        diasAbonados += gzFerias.QTDIASABONOFERI ? Number(gzFerias.QTDIASABONOFERI) : 0;
        limiteFerias -= (Number(diferencaDias) + diasAbonados);
        limiteAbonoFerias -= Number(gzFerias.QTDIASABONOFERI) || 0;

        if(Number(gzFerias.QTDIASABONOFERI) + Number(gzFerias.QTDIASFERIAS) >= 14) {
          existePeriodo14 = true;
        }

        if (
          (isSameDay(dtIniGozoFeriasNovo, dtIniGozoFerias)) ||
          (isSameDay(dtFimGozoFerias, dtFimGozoFeriasNovo)) ||
          (dtIniGozoFeriasNovo > dtIniGozoFerias && dtIniGozoFeriasNovo <= dtFimGozoFerias) ||
          (dtFimGozoFeriasNovo >= dtIniGozoFerias && dtFimGozoFeriasNovo <= dtFimGozoFerias) ||
          (dtFimGozoFeriasNovo >= dtFimGozoFerias && dtIniGozoFeriasNovo <= dtIniGozoFerias)
          ) {
          dtIniGozoFeriasExiste = dtIniGozoFerias;
          dtFimGozoFeriasExiste = dtFimGozoFerias;
          isMesmoPeriodoGozoFerias = true;
          return false;
        }

      });
    }

    if(isMesmoPeriodoGozoFerias) {
      const msg = `Já existe um gozo de férias no período selecionado, início: ${format(dtIniGozoFeriasExiste, 'dd/MM/yyyy')} fim: ${format(dtFimGozoFeriasExiste, 'dd/MM/yyyy')}. Favor Alterar`;
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    const qtDiasFerias = Number(this.main.row.QTDIASFERIAS) + Number(this.main.row.QTDIASABONOFERI);
    const restoDiasFerias = limiteFerias - qtDiasFerias;

    // MINIMO
    if (this.main.row.QTDIASFERIAS < 5) {
      if (feriasReduzidas) {
        const msg = `Obs.: Será permitido o período de férias inferior a 5 dias pois há redução de dias de direito às férias (${qtMaxFerias} dias).`;
        SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_INFO2, 12000);
      } else {
        const msg = `A quantidade de dias a se gozar não pode ser inferior a 5 dias`;
        SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
        return false;
      }
    }

    if(restoDiasFerias < 5 && restoDiasFerias > 0) {
      const msg = "O próximo período de gozo será inferior a 5 dias. Por favor, ajuste a quantidade de dias.";
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    // LIMITES
    if(qtDiasFerias > limiteFerias) {
      const limiteFeriasMsg = limiteFerias < 0 ? 0 : limiteFerias;
      const msg = `O limite de gozo das férias desse Colaborador é: ${limiteFeriasMsg}. Favor Alterar`;
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    if((Number(this.main.row.QTDIASABONOFERI) > Number(limiteAbonoFerias) )) {
      const limiteAbono = limiteAbonoFerias < 0 ? 0 : limiteAbonoFerias;
      const msg = `O limite de abono de férias para esse Colaborador é: ${limiteAbono}. Favor Alterar.`;
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    const dtIniAquis = parse(ferias.DTINIAQUISICAO, 'dd/MM/yyyy HH:mm:ss', new Date());

    if(isBefore(dtIniGozoFeriasNovo, dtIniAquis)) {
      const msg = "A data de início do gozo das férias não pode ser anterior à data de início da aquisição.";
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    if(Number(this.main.row.QTDIASFERIAS) < 0 || Number(this.main.row.QTDIASABONOFERI) < 0) {
      const msg = "Não é permitido o uso de datas negativas.";
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }


    // Calculo de Limite de Periodos
    if(gozoFerias.length >= 3) {
      const msg = "Este colaborador já gozou três períodos de férias. As férias podem ser divididas em até três períodos, no máximo.";
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    if(gozoFerias.length == 2 && qtDiasFerias != limiteFerias) {
      const msg = `Este colaborador já gozou dois períodos de férias. A quantidade de dias que ele deve gozar neste período é ${limiteFerias}.`;
      SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
      return false;
    }

    // Pelo menos 1 período com 14 dias.
    if(!existePeriodo14 && qtDiasFerias < 14 && restoDiasFerias < 14) {
      if (feriasReduzidas) {
        const msg = `Obs.: Será permitido que não haja um período de férias superior a 14 dias pois há redução de dias de direito às férias (${qtMaxFerias} dias).`;
        SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_INFO2, 12000);
      } else {
        const restoDiasFeriasMsg = Math.max(0, limiteFerias);
        const diasGozados = qtMaxFerias - limiteFerias;
        const msg = `Pelo menos um dos períodos de gozo não pode ser inferior a 14 dias.<br>\n Dias gozados: ${diasGozados} <br>\n Dias restantes: ${restoDiasFeriasMsg}`;
        SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR, 7000);
        return false;
      }
    }

    // Ferias em dobro
    const dtInicioProxPeriodo = addYears(dtFimAquisicao, 1);

    if(isAfter(dtFimGozoFeriasNovo, dtInicioProxPeriodo) || isSameDay(dtFimGozoFeriasNovo, dtInicioProxPeriodo)) {
      await DialogUtils.show('Aviso', "Período de Férias solicitado irá gerar pagamento de FÉRIAS EM DOBRO. Deseja continuar");
    }


    return true;
  }

  private async validaInicioFeriasValida() {
    try {
      const dtinigozoferias = parse(this.main.row.DTINIGOZOFERIAS, 'dd/MM/yyyy', new Date());
      const dateAfter30Days = addDays(new Date(), 29);

      // Verifique se a data de início do gozo de férias é pelo menos 30 dias depois da data atual
      if (isAfter(dtinigozoferias, dateAfter30Days)) {
        return true
      }

      const isDp = this.main.user.dp;
      const msg = " A solicitação de início de férias deve ser feita com pelo menos 30 dias de antecedência.";
      // TODO: Alterar label dos botões para "Continuar" e "Cancelar" ao invés de "Sim" e "Não"
      await DialogUtils.show('Aviso', msg, () => {}, () => {}, false, !isDp);

      return false;

    } catch (error) {
      return false;
    }
  }

  private validaFeriasMaisAntiga() {
    try {
      if(this.periodoFerias.length < 2) return true;

      const feriasSelected = this.periodoFerias.find((ferias) => ferias.NRFERIAS == this.main.row.NRFERIAS);
      const feriasOutras = this.periodoFerias.filter((ferias) => ferias.NRFERIAS != this.main.row.NRFERIAS);
      if(!feriasSelected) return true;

      const periodoNotValid = feriasOutras.some((ferias) => {
        const dtAquisicaoOutra = parse(ferias.DTINIAQUISICAO, 'dd/MM/yyyy HH:mm:ss', new Date());
        const dtAquisicaoSelected = parse(feriasSelected.DTINIAQUISICAO, 'dd/MM/yyyy HH:mm:ss', new Date());

        if (isAfter(dtAquisicaoSelected, dtAquisicaoOutra)) {
          const msg = `Você selecionou um período de férias mais recente que não respeita a ordem dos períodos aquisitivos. Por favor, escolha um período de férias anterior para continuar.`;
          SnackbarUtils.showMessage(msg, SnackbarUtils.TYPE_ERROR);
          return true;
        }
        return false;
      });

      return !periodoNotValid;
    } catch (error) {
      return true;
    }
  }

  private get deveMostrarAdiant13(): boolean {
    const tipoSolicitacao = this.main && this.main.tipoSolicitacaoSelected;
    return tipoSolicitacao &&
          tipoSolicitacao.IDEXIBEADIANT13SALAR === 'S';
  }
}